import * as React from 'react';
import { cn } from '@/lib/utils';
import { PostCardBody, PostCardContent, PostCardHeader, PostCardName, PostCardText, PostCardTime } from './post-card';

const PostComment = React.forwardRef(({ className, isPinned = false, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-post-comment',
      // Estilos Base
      'relative m-0 flex animate-fade-in items-start gap-4 border-b border-solid border-bright py-4 last:border-b-0',
      // Estilos Responsivos
      'md:py-4',
      // Variantes
      isPinned && [
        'rounded-[10px] border-b-0 bg-neutral-bright p-2',
        // expanded-calendar
        '[&_.expanded-calendar__tag]:absolute [&_.expanded-calendar__tag]:right-2 [&_.expanded-calendar__tag]:top-2',
        // post-comment__actions
        '[&_.post-comment__actions]:self-end'
      ],
      className
    )}
    {...props}
  />
));
PostComment.displayName = 'PostComment';

const PostCommentContent = React.forwardRef(({ className, ...props }, ref) => (
  <PostCardContent
    ref={ref}
    className={cn('c-post-comment-content', className)}
    {...props}
  />
));
PostCommentContent.displayName = 'PostCommentContent';

const PostCommentHeader = React.forwardRef(({ className, ...props }, ref) => (
  <PostCardHeader
    ref={ref}
    className={cn('c-post-comment-header', 'mb-0 pb-2', className)}
    {...props}
  />
));
PostCommentHeader.displayName = 'PostCommentHeader';

const PostCommentName = React.forwardRef(({ className, ...props }, ref) => (
  <PostCardName
    ref={ref}
    className={cn('c-post-comment-name', className)}
    {...props}
  />
));
PostCommentName.displayName = 'PostCommentName';

const PostCommentTime = React.forwardRef(({ className, ...props }, ref) => (
  <PostCardTime
    ref={ref}
    className={cn('c-post-comment-name', className)}
    {...props}
  />
));
PostCommentTime.displayName = 'PostCommentTime';

const PostCommentBody = React.forwardRef(({ className, ...props }, ref) => (
  <PostCardBody
    ref={ref}
    className={cn('c-post-comment-name', className)}
    {...props}
  />
));
PostCommentBody.displayName = 'PostCommentBody';

const PostCommentText = React.forwardRef(({ className, ...props }, ref) => (
  <PostCardText
    ref={ref}
    className={cn('c-post-comment-name', className)}
    {...props}
  />
));
PostCommentText.displayName = 'PostCommentText';

const PostCommentList = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-post-comment-list',
      // Estilos base
      'w-full border-t-[3px] border-solid border-t-primary-lightest pt-4',
      className
    )}
    {...props}
  />
));
PostCommentList.displayName = 'PostCommentList';

export { PostCommentList, PostComment, PostCommentContent, PostCommentHeader, PostCommentName, PostCommentTime, PostCommentBody, PostCommentText };
